@if (!isLoadingNotasVertente && !notasVertente) {
  <p>Não foram encontrados dados de maturidade</p>
}
@if (isLoadingNotasVertente) {
  <app-loading-spinner></app-loading-spinner>
}
@if (!isLoadingNotasVertente && notasVertente) {
  <div fxLayout="column" style="padding-left: 10px; padding-right: 10px;">
    <div class="box">
      <p class="titulo-grafico">Nível de Maturidade por Grupo de Vertentes</p>
      <mat-accordion class="accordion-maturidade">
        <mat-expansion-panel class="mat-elevation-z0" class="grey-bg">
          <mat-expansion-panel-header class="panel-height" style="padding-left: 40px; padding-right: 40px;">
            <mat-panel-title fxLayout="row" fxLayoutGap="15px">
              <p class="estagio-maturidade title-accordion">{{(notasVertente.estagioLabel)}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="container-maturidade">
              <div class="container-dados-maturidade" fxLayout="row">
                <div class="grafico-data" fxLayout="column">
                  <div class="resumo-grafico-container">
                    <p class="estagio-maturidade">{{(notasVertente.estagioLabel)}}
                      <span class="nota-maturidade">{{formatarDecimal(notasVertente.pontuacaoFinal)}}</span>
                    </p>
                    <p class="subtitulo-grafico">Grau de Maturidade do Ecossistema</p>
                  </div>
                  <div class="grafico-subtitle">
                    <div class="grafico-container">
                      <app-spider-web-chart-public [notaVertente]="notasVertente" [renderTo]="">
                      </app-spider-web-chart-public>
                    </div>
                    @if (innerWidth >= 1680) {
                      <div fxLayoutGap="10px" class="maturidade-detail">
                        <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
                          <div class="maturidade-detail-header">
                            <div class="maturidade-detail-header-margin">
                              <div fxFlex="100" class="header-table-detalhes-maturidade">Legenda Estágio de Maturidade</div>
                            </div>
                          </div>
                          <div class="maturidade-detail-body">
                            <div class="maturidade-detail-body-margin" fxLayout="row">
                              <div fxFlex="20" class="cell">
                                <div class="first">
                                  <span fxLayoutAlign="end" style="font-weight: bold;">Nota</span>
                                </div>
                                <div class="second">
                                  <span fxLayoutAlign="end" style="font-weight: bold;">Classificação</span>
                                </div>
                              </div>
                              <div fxFlex="80" style="justify-content: space-between;" fxLayout="row">
                                <div class="cell first-column">
                                  <div class="first">
                                    <span class="txt-left display-block">De 0 a 11,99</span>
                                  </div>
                                  <div class="second">
                                    <span class="txt-left">Inicial</span>
                                  </div>
                                </div>
                                <div class="cell">
                                  <div class="first">
                                    <span class="txt-left display-block">De 12 a 17,99</span>
                                  </div>
                                  <div class="second">
                                    <span class="txt-left">Em Estruturação</span>
                                  </div>
                                </div>
                                <div class="cell">
                                  <div class="fist">
                                    <span class="txt-left display-block">De 18 a 23,99</span>
                                  </div>
                                  <div class="second">
                                    <span class="txt-left">Em Desenvolvimento</span>
                                  </div>
                                </div>
                                <div class="cell">
                                  <div class="first">
                                    <span class="txt-left display-block">De 24 a 30</span>
                                  </div>
                                  <div class="second">
                                    <span class="txt-left">Consolidado</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (innerWidth < 1680) {
                      <div fxLayoutGap="10px" class="maturidade-detail">
                        <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
                          <div class="maturidade-detail-header">
                            <div class="maturidade-detail-header-margin">
                              <div fxFlex="100" class="header-table-detalhes-maturidade">Legenda Estágio de Maturidade</div>
                            </div>
                          </div>
                          <div class="maturidade-detail-body">
                            <div class="maturidade-detail-body-margin" fxLayout="column">
                              <div fxFlex="100" fxLayout="row">
                                <span fxFlex="40" fxLayoutAlign="start" style="font-weight: bold;" class="cell">Nota</span>
                                <span fxFlex="60" fxLayoutAlign="start" style="font-weight: bold;"
                                class="cell">Classificação</span>
                              </div>
                              <div fxLayout="row" fxFlex="100">
                                <span fxFlex="40" class="cell txt-left display-block">De 0 a 11,99</span>
                                <span fxFlex="60" class="cell txt-left">Inicial</span>
                              </div>
                              <div fxLayout="row" fxFlex="100">
                                <span fxFlex="40" class="cell txt-left display-block">De 12 a 17,99</span>
                                <span fxFlex="60" class="cell txt-left">Em Estruturação</span>
                              </div>
                              <div fxLayout="row" fxFlex="100">
                                <span fxFlex="40" class="cell txt-left display-block">De 18 a 23,99</span>
                                <span fxFlex="60" class="cell txt-left">Em Desenvolvimento</span>
                              </div>
                              <div fxLayout="row" fxFlex="100">
                                <span fxFlex="40" class="cell txt-left display-block">De 24 a 30</span>
                                <span fxFlex="60" class="cell txt-left">Consolidado</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="container-tabela-dados">
                  <div fxLayoutGap="10px" class="" fxFlex="100">
                    <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center">
                      <div class="">
                        <div class="container-header-tabela-dados-integrantes" fxLayout="row">
                          <div fxFlex="20" class="container-header">
                            <span class="header-dados-integrante" fxLayoutAlign="end"
                            style="padding-right: 20px;">Vertente</span>
                          </div>
                          <div fxFlex="25" class="container-header">
                            <span class="header-dados-integrante">Integrantes da Vertente</span>
                          </div>
                          <div fxFlex="15" class="container-header">
                            <span class="header-dados-integrante">Grau de Efetividade</span>
                          </div>
                          <div fxFlex="15" class="container-header">
                            <span class="header-dados-integrante">Grau de Integração</span>
                          </div>
                          <div fxFlex="25" class="container-header">
                            <span class="header-dados-integrante">Grau de Maturidade do Ecossistema</span>
                          </div>
                        </div>
                      </div>
                      <div>
                        @for (vertente of notasVertente.notasVertente; track vertente; let i = $index) {
                          <div class="txt-right-dados-vertente " fxLayout="column"
                            [ngClass]="{'grey-line': i%2 == 0, 'white-line': i%2 != 0}">
                            <div fxFlex="100" fxLayout="row" class="row-dados-vertente">
                              <span fxFlex="20" fxLayoutAlign="center" class="label-vertente coluna-dados-vertentes"
                              style="text-align: center;">{{vertente.nomeVertente}}</span>
                              <div fxFlex="55">
                                <div fxLayout="column" fxFlex="100">
                                  @for (integrante of vertente.integrantes; track integrante; let s = $index) {
                                    <div fxLayout="row"
                                      class="item-dados-vertente-subvertente"
                                      [ngStyle]="{'padding': (s == vertente.integrantes.length) ? '0' : '10px'}">
                                      <span fxFlex="46"
                                      class="coluna-dados-vertentes txt-left no-padding-right">{{integrante.nome}}</span>
                                      <span fxFlex="27"
                                      class="coluna-dados-vertentes txt-center">{{formatarValor(integrante.grauEfetividade)}}</span>
                                      @if (!isVertenteNotaUnica(vertente.nomeVertente)) {
                                        <span fxFlex="27" class="coluna-dados-vertentes txt-center"
                                        >{{formatarValor(integrante.grauIntegracao)}}</span>
                                      }
                                      @if (isVertenteNotaUnica(vertente.nomeVertente)) {
                                        <span fxFlex="27" class="coluna-dados-vertentes txt-center"
                                        >-</span>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <span fxFlex="25"
                              class="label-vertente coluna-dados-vertentes maturidade-integrante" style="border-right: none;">{{vertente.pontuacao}}</span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }

  @if (!isLoadingNotasSetor && !notasSetor) {
    <p>Não foram encontrados dados de maturidade por setor</p>
  }
  @if (isLoadingNotasSetor) {
    <app-loading-spinner></app-loading-spinner>
  }
  @if (!isLoadingNotasSetor && notasSetor) {
    <app-detalhes-maturidade-setor-public [notasPorSetor]="notasSetor">
    </app-detalhes-maturidade-setor-public>
  }
